import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { authHeader } from '@H';
import { confirmAlert } from 'react-confirm-alert';
import BankList from './BankList';

const Banks = () => {
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const editRef = useRef(null);
  const [bankData, setBankData] = useState({
    bank_name: '',
    updated: false,
    editMode: false,
  });

  const handleChange = (e) => {
    setBankData({
      ...bankData,
      [e.target.name]: e.target.value,
    });
  };

  const cancelEdit = () => {
    setBankData({
      bank_name: '',
      updated: bankData.updated,
      editMode: false,
    });
  };

  const handleEditMode = (bank) => {
    setBankData({
      uuid: bank.uuid,
      bank_name: bank.bank_name,
      updated: bankData.updated,
      editMode: true,
    });

    if (editRef.current) {
      window.scrollTo({
        behavior: 'smooth',
        top: editRef.current.offsetTop - 150,
      });
    }
  };

  const confirmSubmit = (e) => {
    const { bank_name } = bankData;
    confirmAlert({
      title: 'Are you sure you want to',
      message: bankData.editMode ? `update ${bank_name}` : 'add a new bank',
      buttons: [
        {
          label: 'Yes',
          onClick: () => submitForm(e),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const headers = authHeader(1);
    const url = `${process.env.API_URL}/utils/banks/`;
    let method = 'POST';
    let formData = bankData;

    if (bankData.editMode) {
      method = 'PUT';
      formData.bank_name = bankData.bank_name;
    }

    axios({
      method,
      url,
      data: formData,
      headers,
    })
      .then(() => {
        toast.success('Bank name added successfully');
        // Check if the editRef is defined before scrolling
        if (editRef.current) {
          window.scrollTo({
            behavior: 'smooth',
            top: editRef.current.offsetTop - 150,
          });
        }
        setIsSubmitting(false);
        setBankData({
          bank_name: '',
          updated: !bankData.updated,
          editMode: false,
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <section className="widget full-width form-table" ref={editRef}>
        <header>
          <h3>Banks</h3>
        </header>
        <main>
          <div className="form-content">
            <table>
              <thead>
                <tr>
                  <th>Bank Name</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr className={`${bankData.editMode ? 'highlight-bg' : ''}`}>
                  <td>
                    <div className="input-wrapper">
                      <input
                        name="bank_name"
                        type="text"
                        onChange={handleChange}
                        placeholder="Bank name"
                        value={bankData.bank_name}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="form-actions">
              <button className="submit" type="submit" onClick={confirmSubmit}>
                Submit
              </button>
              {bankData.editMode && (
                <button className="red-btn" onClick={cancelEdit}>
                  Cancel
                </button>
              )}
            </div>
          </div>
        </main>
      </section>
      <BankList key={bankData.updated} onEdit={handleEditMode} />
    </>
  );
};

export { Banks };
